import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';

export const typeOfBarChartCheckboxesDialog = 'typeOfBarChartCheckboxesDialog';

export const rangeElementsInChunkPicker = 3;
export const sizeChunckOfGroups = 30;
export const sizeChunckOfGroupsNewAuthorSearchFilter = 100;

export const sortingOptionsTypeMap = {
  [occurrence]: 'Occurrence',
  [byValue]: 'Alphanumerical',
};

export const barChartCheckboxesDialogActionType = 'barChartCheckboxesDialogActionType';
